import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConceptFamilyModel } from './conceptfamily.model';
import { ConceptFamilyService } from './conceptfamily.service';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-conceptfamily',
    templateUrl: './conceptfamily.component.html',
    styleUrls: ['./conceptfamily.component.css'],
    standalone: false
})
export class ConceptFamilyComponent implements OnInit {
  conceptfamily = new ConceptFamilyModel();
  errors = {};

  submit(): void {}

  constructor(
    private conceptFamilyService: ConceptFamilyService,
    private route: ActivatedRoute,
    private router: Router,
    public dummy: DummyComponent
  ) {}

  saveData = (conceptfamily): void => {
    if (conceptfamily.uid == null) {
      this.conceptFamilyService.addData(conceptfamily)
        .then(result => {
          this.conceptfamily = result;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    } else {
      this.conceptFamilyService.editData(conceptfamily.uid, conceptfamily)
        .then(result => {
          this.conceptfamily = result;
          this.dummy.redirectTo(this.router.url);
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    }
  };

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const uid = params['uid'];
      if (uid != null) {
        this.conceptFamilyService.loadData(uid).then(conceptfamily => this.conceptfamily = conceptfamily);
      }
    });
  }

  returnToIndex = (): void => {
    this.router.navigate(['/concept/conceptfamily']);
  };
}